import { render } from "./Underline.vue?vue&type=template&id=1ec0288a"
import script from "./Underline.vue?vue&type=script&lang=js"
export * from "./Underline.vue?vue&type=script&lang=js"
script.render = render

export default script